import Dashboard from "../pages/Dashboard/Dashboard";
import PlayerArea from "../pages/PlayerArea/PlayerArea";
import PlayerProfilePage from "../pages/PlayerArea/PlayerProfilePage";
import PlayerAccountPage from "../pages/PlayerArea/PlayerAccountPage";
import PlayerRegistration from "../pages/PlayerArea/PlayerRegistration";
import SeasonManagement from "../pages/SeasonManagement";
import CourseManagement from "../pages/CoursesManagement";
import NewsAnnoucement from "../pages/News&Annoucement";
import SponsorManagement from "../pages/SponsorManagement";
import CourseDetails from "../pages/CoursesManagement/CourseDetails";
import Tournaments from "../pages/POTY/Tournaments";
import TournamentDetails from "../pages/TournamentDetails";
import POTYTournamentDetails from "../pages/POTYTournamentDetails";
import Leaderboard from "../pages/POTY/Leaderboard";
import SMP from "../pages/Smp";
import SMPScorecard from "../pages/Smp/SMPScorecard";
import Scoreboard from "../pages/Dmp/Scoreboard";
import DMP from "../pages/Dmp";
import TournamentDetailView from "../pages/TournamentDetails/TournamentDetailView";
import Teams from "../pages/POTY/Teams";
import TeamRanking from "../pages/POTY/TeamRanking";

const DashboardIcon = require("../assets/images/dahsboard.png");
const SeasonsIcon = require("../assets/images/seasons.png");
const potyIcon = require("../assets/images/poty.png");
const lclIcon = require("../assets/images/lcl.png");
const smpIcon = require("../assets/images/smp.png");
const dmpIcon = require("../assets/images/dmp.png");
const sponsorsIcon = require("../assets/images/sponsors.png");
const coursesIcon = require("../assets/images/courses.png");
const newsIcon = require("../assets/images/news-announcements.png");
const playersAreaIcon = require("../assets/images/players-area.png");
const otherChaptersIcon = require("../assets/images/other-chapters.png");

export const pathLocations = [
    {
        title: "Dashboard",
        path: "/",
        link: "/",
        icon: DashboardIcon,
        component: Dashboard,
        exact: true,
        isEnabled: true,
    },
    {
        title: "League",
        path: "/leagueManagement",
        link: "/leagueManagement",
        icon: SeasonsIcon,
        exact: true,
        component: SeasonManagement,
        isEnabled: true,
    },
    {
        title: "POTY",
        icon: potyIcon,
        isEnabled: true,
        children: [
            {
                title: "Leaderboard",
                path: "/poty-leaderboard",
                link: "/poty-leaderboard",
                icon: potyIcon,
                isEnabled: true,
            },
            {
                title: "Tournaments",
                path: "/poty-tournaments",
                link: "/poty-tournaments",
                icon: potyIcon,
                isEnabled: true,
            },
        ],
    },
    {
        title: "LCL",
        icon: lclIcon,
        isEnabled: true,
        children: [
            {
                title: "Teams",
                path: "/lcl/poty-teams",
                link: "/lcl/poty-teams",
                icon: potyIcon,
                isEnabled: true,
            },
            {
                title: "Team Ranking",
                path: "/lcl/team-ranking",
                link: "/lcl/team-ranking",
                icon: potyIcon,
                isEnabled: true,
            },
        ],
    },
    {
        title: "Team Ranking",
        path: "/lcl/team-ranking",
        link: "/lcl/team-ranking",
        icon: null,
        isEnabled: false,
        component: TeamRanking,
        exact: true,
    },
    {
        title: "Tournaments",
        path: "/poty-tournaments",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: Tournaments,
        exact: true,
    },
    {
        title: "Leaderboard",
        path: "/poty-leaderboard",
        link: "/poty-leaderboard",
        icon: potyIcon,
        isEnabled: false,
        component: Leaderboard,
        exact: true,
    },
    {
        title: "Teams",
        path: "/lcl/poty-teams",
        link: "/lcl/poty-teams",
        icon: null,
        isEnabled: false,
        component: Teams,
        exact: true,
    },
    {
        title: "Tournament Details",
        path: "/poty-tournaments/:id/tournament-details",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: TournamentDetails,
    },
    {
        title: "Tournament Detail Listing",
        path: "/poty-tournaments/tournament-detail-listing/:id",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: POTYTournamentDetails,
    },
    {
        title: "Tournament Details",
        path: "/poty-tournaments/:id/view",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: TournamentDetailView,
    },
    {
        title: "LCL",
        path: "/lcl",
        link: "/lcl",
        icon: lclIcon,
        isEnabled: false,
    },
    {
        title: "Scorecard",
        path: "/smp/scorecard/:id",
        link: "/smp/scorecard/:id",
        icon: smpIcon,
        isEnabled: false,
        component: SMPScorecard,
    },
    {
        title: "Sponsors",
        path: "/sponsors",
        link: "/sponsors",
        icon: sponsorsIcon,
        component: SponsorManagement,
        isEnabled: true,
    },
    {
        title: "SMP",
        path: "/smp",
        link: "/smp",
        icon: smpIcon,
        isEnabled: true,
        component: SMP,
    },
    {
        title: "DMP",
        path: "/dmp",
        link: "/dmp",
        icon: dmpIcon,
        isEnabled: true,
        component: DMP,
    },
    {
        title: "DMP",
        path: "/dmp/scorecard/:id",
        link: "/dmp/scorecard",
        icon: null,
        component: Scoreboard,
        isEnabled: true,
    },
    {
        title: "Courses",
        path: "/courses",
        link: "/courses",
        icon: coursesIcon,
        component: CourseManagement,
        isEnabled: true,
    },
    {
        title: "Courses",
        path: "/courseDetails/:id",
        link: "/courseDetails",
        icon: null,
        component: CourseDetails,
        isEnabled: true,
    },
    {
        title: "News/Announcements",
        path: "/news-annoucement",
        link: "/news-annoucement",
        icon: newsIcon,
        component: NewsAnnoucement,
        isEnabled: true,
    },
    {
        title: "Players Area",
        path: "/players-area",
        link: "/players-area",
        icon: playersAreaIcon,
        exact: true,
        component: PlayerArea,
        isEnabled: true,
    },
    {
        title: "Players Area Player Profile",
        path: "/player-profile/:id",
        link: "/player-profile/:id",
        icon: null,
        exact: true,
        component: PlayerProfilePage,
        isEnabled: true,
    },
    {
        title: "Players Area Player Registration",
        path: "/playerRegistration",
        link: "/playerRegistration",
        icon: null,
        exact: true,
        component: PlayerRegistration,
        isEnabled: true,
    },
    {
        title: "Players Area Player Account",
        path: "/playerAccount/:id",
        link: "/playerAccount",
        icon: null,
        exact: false,
        component: PlayerAccountPage,
        isEnabled: true,
    },
    {
        title: "Players Area Player Account",
        path: "/playerAccount/",
        link: "/playerAccount",
        icon: null,
        exact: false,
        component: PlayerAccountPage,
        isEnabled: true,
    },
    {
        title: "Other Chapters",
        path: "/other-chapters",
        link: "/other-chapters",
        icon: otherChaptersIcon,
        isEnabled: false,
    },
];

export const adminPathLocations = [
    {
        title: "Dashboard",
        path: "/",
        link: "/",
        icon: DashboardIcon,
        component: Dashboard,
        exact: true,
        isEnabled: true,
    },
    {
        title: "League",
        path: "/leagueManagement",
        link: "/leagueManagement",
        icon: SeasonsIcon,
        exact: true,
        component: SeasonManagement,
        isEnabled: true,
    },
    {
        title: "POTY",
        icon: potyIcon,
        isEnabled: true,
        children: [
            {
                title: "Leaderboard",
                path: "/poty-leaderboard",
                link: "/poty-leaderboard",
                icon: potyIcon,
                isEnabled: true,
            },
            {
                title: "Tournaments",
                path: "/poty-tournaments",
                link: "/poty-tournaments",
                icon: potyIcon,
                isEnabled: true,
            },
        ],
    },
    {
        title: "LCL",
        icon: lclIcon,
        isEnabled: true,
        children: [
            {
                title: "Teams",
                path: "/lcl/poty-teams",
                link: "/lcl/poty-teams",
                icon: potyIcon,
                isEnabled: true,
            },
            {
                title: "Team Ranking",
                path: "/lcl/team-ranking",
                link: "/lcl/team-ranking",
                icon: potyIcon,
                isEnabled: true,
            },
        ],
    },
    {
        title: "Team Ranking",
        path: "/team-ranking",
        link: "/team-ranking",
        icon: null,
        isEnabled: false,
        component: TeamRanking,
        exact: true,
    },
    {
        title: "Teams",
        path: "/lcl/poty-teams",
        link: "/lcl/poty-teams",
        icon: null,
        isEnabled: false,
        component: Teams,
        exact: true,
    },
    {
        title: "Tournaments",
        path: "/poty-tournaments",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: Tournaments,
        exact: true,
    },
    {
        title: "Leaderboard",
        path: "/poty-leaderboard",
        link: "/poty-leaderboard",
        icon: potyIcon,
        isEnabled: false,
        component: Leaderboard,
        exact: true,
    },
    {
        title: "Tournament Details",
        path: "/poty-tournaments/:id/tournament-details",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: TournamentDetails,
    },
    {
        title: "Tournament Details",
        path: "/poty-tournaments/:id/view",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: TournamentDetailView,
    },
    {
        title: "Tournament Detail Listing",
        path: "/poty-tournaments/tournament-detail-listing/:id",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: POTYTournamentDetails,
    },
    {
        title: "LCL",
        path: "/lcl",
        link: "/lcl",
        icon: lclIcon,
        isEnabled: false,
    },
    {
        title: "Scorecard",
        path: "/smp/scorecard/:id",
        link: "/smp/scorecard/:id",
        icon: smpIcon,
        isEnabled: false,
        component: SMPScorecard,
    },
    {
        title: "SMP",
        path: "/smp",
        link: "/smp",
        icon: smpIcon,
        isEnabled: true,
        component: SMP,
    },
    {
        title: "DMP",
        path: "/dmp",
        link: "/dmp",
        icon: dmpIcon,
        isEnabled: true,
        component: DMP,
    },
    {
        title: "DMP",
        path: "/dmp/scorecard/:id",
        link: "/dmp/scorecard",
        icon: null,
        component: Scoreboard,
        isEnabled: true,
    },
    {
        title: "Courses",
        path: "/courses",
        link: "/courses",
        icon: coursesIcon,
        component: CourseManagement,
        isEnabled: true,
    },
    {
        title: "Courses",
        path: "/courseDetails/:id",
        link: "/courseDetails",
        icon: null,
        component: CourseDetails,
        isEnabled: true,
    },
    {
        title: "News/Announcements",
        path: "/news-annoucement",
        link: "/news-annoucement",
        icon: newsIcon,
        component: NewsAnnoucement,
        isEnabled: true,
    },
    {
        title: "Players Area",
        path: "/players-area",
        link: "/players-area",
        icon: playersAreaIcon,
        exact: true,
        component: PlayerArea,
        isEnabled: true,
    },
    {
        title: "Players Area Player Profile",
        path: "/player-profile/:id",
        link: "/player-profile/:id",
        icon: null,
        exact: true,
        component: PlayerProfilePage,
        isEnabled: true,
    },
    {
        title: "Players Area Player Registration",
        path: "/playerRegistration",
        link: "/playerRegistration",
        icon: null,
        exact: true,
        component: PlayerRegistration,
        isEnabled: true,
    },
    {
        title: "Players Area Player Account",
        path: "/playerAccount/:id",
        link: "/playerAccount",
        icon: null,
        exact: false,
        component: PlayerAccountPage,
        isEnabled: true,
    },
    {
        title: "Players Area Player Account",
        path: "/playerAccount/",
        link: "/playerAccount",
        icon: null,
        exact: false,
        component: PlayerAccountPage,
        isEnabled: true,
    },
    {
        title: "Other Chapters",
        path: "/other-chapters",
        link: "/other-chapters",
        icon: otherChaptersIcon,
        isEnabled: false,
    },
];

export const PlayerPathLocations = [
    {
        title: "Dashboard",
        path: "/",
        link: "/",
        icon: DashboardIcon,
        component: Dashboard,
        exact: true,
        isEnabled: true,
    },
    {
        title: "POTY",
        icon: potyIcon,
        isEnabled: true,
        children: [
            {
                title: "Leaderboard",
                path: "/poty-leaderboard",
                link: "/poty-leaderboard",
                icon: potyIcon,
                isEnabled: true,
            },
            {
                title: "Tournaments",
                path: "/poty-tournaments",
                link: "/poty-tournaments",
                icon: potyIcon,
                isEnabled: true,
            },
        ],
    },
    {
        title: "LCL",
        icon: lclIcon,
        isEnabled: true,
        children: [
            {
                title: "Team Ranking",
                path: "/lcl/team-ranking",
                link: "/lcl/team-ranking",
                icon: potyIcon,
                isEnabled: true,
            },
        ],
    },
    {
        title: "Team Ranking",
        path: "/team-ranking",
        link: "/team-ranking",
        icon: null,
        isEnabled: false,
        component: TeamRanking,
        exact: true,
    },
    {
        title: "Teams",
        path: "/lcl/poty-teams",
        link: "/lcl/poty-teams",
        icon: null,
        isEnabled: false,
        component: Teams,
        exact: true,
    },
    {
        title: "Tournaments",
        path: "/poty-tournaments",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: Tournaments,
        exact: true,
    },
    {
        title: "Leaderboard",
        path: "/poty-leaderboard",
        link: "/poty-leaderboard",
        icon: potyIcon,
        isEnabled: false,
        component: Leaderboard,
        exact: true,
    },
    {
        title: "Tournament Details",
        path: "/poty-tournaments/:id/view",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: TournamentDetailView,
    },
    {
        title: "Tournament Detail Listing",
        path: "/poty-tournaments/tournament-detail-listing/:id",
        link: "/poty-tournaments",
        icon: null,
        isEnabled: false,
        component: POTYTournamentDetails,
    },
    {
        title: "LCL",
        path: "/lcl",
        link: "/lcl",
        icon: lclIcon,
        isEnabled: false,
    },
    {
        title: "Scorecard",
        path: "/smp/scorecard/:id",
        link: "/smp/scorecard/:id",
        icon: smpIcon,
        isEnabled: false,
        component: SMPScorecard,
    },
    {
        title: "SMP",
        path: "/smp",
        link: "/smp",
        icon: smpIcon,
        isEnabled: true,
        component: SMP,
    },
    {
        title: "DMP",
        path: "/dmp",
        link: "/dmp",
        icon: dmpIcon,
        isEnabled: true,
        component: DMP,
    },
    {
        title: "DMP",
        path: "/dmp/scorecard/:id",
        link: "/dmp/scorecard",
        icon: null,
        component: Scoreboard,
        isEnabled: true,
    },
    {
        title: "Courses",
        path: "/courseDetails/:id",
        link: "/courseDetails",
        icon: null,
        component: CourseDetails,
        isEnabled: true,
    },
    {
        title: "Players Area",
        path: "/players-area",
        link: "/players-area",
        icon: playersAreaIcon,
        exact: true,
        component: PlayerArea,
        isEnabled: true,
    },
    {
        title: "Players Area Player Profile",
        path: "/player-profile/:id",
        link: "/player-profile/:id",
        icon: null,
        exact: true,
        component: PlayerProfilePage,
        isEnabled: true,
    },
    {
        title: "Players Area Player Registration",
        path: "/playerRegistration",
        link: "/playerRegistration",
        icon: null,
        exact: true,
        component: PlayerRegistration,
        isEnabled: true,
    },
    {
        title: "Players Area Player Account",
        path: "/playerAccount/:id",
        link: "/playerAccount",
        icon: null,
        exact: false,
        component: PlayerAccountPage,
        isEnabled: true,
    },
    {
        title: "Players Area Player Account",
        path: "/playerAccount/",
        link: "/playerAccount",
        icon: null,
        exact: false,
        component: PlayerAccountPage,
        isEnabled: true,
    },
    {
        title: "Other Chapters",
        path: "/other-chapters",
        link: "/other-chapters",
        icon: otherChaptersIcon,
        isEnabled: false,
    },
];
